<ul class="list-group list-group-horizontal mt-5 float-end">
  <li
    [ngClass]="
      activePage == 'HOME'
        ? 'list-group-item border-0 menu-item active-menu-item'
        : 'list-group-item border-0 menu-item'
    "
    (click)="navigateTo('')"
  >
    HOME
  </li>

  <li class="list-group-item border-0">
    <img
      id="user-profile-info"
      *ngIf="isImageFound"
      [src]="userImage"
      class="{{
        environmentColor == 'red'
          ? 'profile-picture-dev-uat'
          : 'profile-picture-prod'
      }}"
      (click)="onClickUserImage()"
    />
    <img
      id="user-profile-info-image-not-found"
      *ngIf="!isImageFound"
      src="../../../../../../assets/images/user-not-found-icon.png"
      class="user-not-found"
      (click)="onClickUserImage()"
    />
    <br />
    <div *ngIf="isClickedUserImage" class="user-info">
      <img
        *ngIf="isImageFound"
        [src]="userImage"
        class="profile-picture-info"
      />
      <img
        *ngIf="!isImageFound"
        src="../../../../../../assets/images/user-not-found-icon.png"
        class="user-not-found-info"
      />
      <p class="text-center mb-0">{{ username }}</p>
      <p class="text-center fs-13">{{ region }}</p>
      <hr />

      <p
        *ngIf="isViewer || isAdmin || isSuperAdmin"
        [ngClass]="
          activePage == 'LOOKUP USERS'
            ? 'ps-2 fs-14 text-start active-menu-item'
            : 'ps-2 fs-14 text-start'
        "
        (click)="navigateTo('/lookup')"
      >
        LOOKUP USERS
      </p>

      <p
        *ngIf="isAdmin || isSuperAdmin"
        [ngClass]="
          activePage == 'CREATE USERS'
            ? 'ps-2 fs-14 text-start active-menu-item'
            : 'ps-2 fs-14 text-start'
        "
        (click)="navigateTo('/create')"
      >
        CREATE USERS
      </p>

      <p
        *ngIf="isAdmin || isSuperAdmin"
        [ngClass]="
          activePage == 'UPDATE USERS'
            ? 'ps-2 fs-14 text-start active-menu-item'
            : 'ps-2 fs-14 text-start'
        "
        (click)="navigateTo('/update')"
      >
        UPDATE USERS
      </p>

      <p
        *ngIf="isSuperAdmin"
        [ngClass]="
          activePage == 'DELETE USERS'
            ? 'ps-2 fs-14 text-start active-menu-item'
            : 'ps-2 fs-14 text-start'
        "
        (click)="navigateTo('/delete')"
      >
        DELETE USERS
      </p>

      <p
        *ngIf="isAdmin || isSuperAdmin"
        [ngClass]="
          activePage == 'RESTORE USERS'
            ? 'ps-2 fs-14 text-start active-menu-item'
            : 'ps-2 fs-14 text-start'
        "
        (click)="navigateTo('/restore')"
      >
        RESTORE USERS
      </p>

      <table class="ms-3">
        <tr>
          <td><fa-icon [icon]="faSignOut"></fa-icon></td>
          <td>
            <button class="btn btn-user-info" (click)="logout()">
              Sign out
            </button>
          </td>
        </tr>
      </table>

      <hr />
      <i class="ps-2 fs-14">Change Region</i><br />
      <table class="ms-3 mb-2">
        <tr *ngIf="region != 'North America'">
          <td>
            <fa-icon [icon]="faEarthAmericas"></fa-icon>
          </td>
          <td>
            <button
              class="btn btn-user-info"
              (click)="changeRegion('North America')"
            >
              North America
            </button>
          </td>
        </tr>
        <tr *ngIf="region != 'Middle East'">
          <td><fa-icon [icon]="faAnkh" class="icon"></fa-icon></td>
          <td>
            <button
              class="btn btn-user-info"
              (click)="changeRegion('Middle East')"
            >
              Middle East
            </button>
          </td>
        </tr>
      </table>
      <div *ngIf="isSuperAdmin">
        <hr />
        <i class="ps-2 fs-14">Settings</i><br />
        <table class="ms-3 mb-2">
          <tr>
            <td>
              <fa-icon [icon]="faGear"></fa-icon>
            </td>
            <td>
              <button
                class="btn btn-user-info"
                (click)="navigateTo('/settings')"
              >
                Settings
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </li>
</ul>
